<script setup lang="ts">
import Icon from "./Icon.vue";

const props = withDefaults(
  defineProps<{
    modelValue: number;
    step?: number;
    min?: number;
    max?: number;
    unit?: string;
    decreaseLabel?: string;
    increaseLabel?: string;
  }>(),
  { step: 5, min: 0, max: 999, decreaseLabel: "Weniger", increaseLabel: "Mehr" },
);
const emit = defineEmits<{ "update:modelValue": [number] }>();

/** Clamping lives here so every caller gets the same bounds behaviour. */
function set(next: number) {
  emit("update:modelValue", Math.min(props.max, Math.max(props.min, next)));
}
</script>
<template>
  <div class="cw-stepper">
    <button
      type="button"
      class="cw-stepper__btn"
      :aria-label="decreaseLabel"
      :disabled="modelValue <= min"
      @click="set(modelValue - step)"
    >
      <Icon
        name="minus"
        :size="16"
      />
    </button>
    <span class="cw-stepper__val">{{ modelValue }}</span>
    <span
      v-if="unit"
      class="cw-stepper__unit"
    >{{ unit }}</span>
    <button
      type="button"
      class="cw-stepper__btn"
      :aria-label="increaseLabel"
      :disabled="modelValue >= max"
      @click="set(modelValue + step)"
    >
      <Icon
        name="plus"
        :size="16"
      />
    </button>
  </div>
</template>
